/*
---------------------------------
Module - events-search-form
---------------------------------
*/

import flatpickr from "flatpickr";

(function () {

    const eventsSearchForm = (function () {

        let elEventsSearchForm;
        let elAutoDateField;
        let fpDateFromField;
        let fpDateToField;

        let today;
        let weekendStart;
        let weekendEnd;
        let lastDateOfMonth;

        function setupAutoDateField() {

            today = elAutoDateField.getAttribute("data-today") || "today";
            weekendStart =  elAutoDateField.getAttribute("data-weekend-start");
            weekendEnd =  elAutoDateField.getAttribute("data-weekend-end");
            lastDateOfMonth =  elAutoDateField.getAttribute("date-last-date-of-month");

            elAutoDateField.addEventListener("change", function(event) {

                // By default, today is used as the min date
                let fromDate = today;
                let toDate;

                let selectedValue = this.value;

                if (selectedValue) {

                    switch(selectedValue) {

                        case "this-week":

                            // Range will be from today to Sunday
                            toDate = weekendEnd;

                            break;

                        case "this-weekend":

                            // Weekend starts from Friday to Sunday
                            // If the default (today) is not yet Friday, we need to make Friday is the date to use
                            // If today is Friday, keep using today
                            if (today < weekendStart) {
                                fromDate = weekendStart;
                            }

                            toDate = weekendEnd;

                            break;

                        case "this-month":

                            toDate = lastDateOfMonth;

                            break;

                    }

                    fpDateFromField.setDate(fromDate);
                    fpDateToField.set("minDate", fromDate);

                    fpDateToField.setDate(toDate);
                    fpDateFromField.set("maxDate", toDate);

                } else {

                    // User has explicitly selected "All dates" which is the default blank
                    // Clear datepicker (FROM and TO) fields
                    fpDateToField.clear()
                    fpDateFromField.clear();

                }

            });

        }

        function setupDatePickerFields() {

            let elDateFromField = document.querySelector(".events-search-form__date-from");
            let elDateToField = document.querySelector(".events-search-form__date-to");

            // From datepicker field
            fpDateFromField = flatpickr(elDateFromField, {
                altInput: true,
                altFormat: "j F Y",
                dateFormat: "Ymd",
                minDate: "today",
                disableMobile: "true",
                locale: {
                    weekdays: {
                        shorthand: ["S", "M", "T", "W", "T", "F", "S"],
                        longhand: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                        ],
                    }
                },
                onReady: (dateObj, dateStr, instance) => {
                    // Apply same aria-label from original field to datepicker field
                    instance.altInput.setAttribute('aria-label', elDateFromField.getAttribute("aria-label"));
                },
                onChange: function(selectedDates, dateStr, instance) {

                    fpDateToField.set("minDate", dateStr);

                    // Reset auto date field
                    elAutoDateField.selectedIndex = 0;

                },

            });

            elDateFromField.setAttribute("readonly", false);

            // From datepicker field
            fpDateToField = flatpickr(elDateToField, {
                altInput: true,
                altFormat: "j F Y",
                dateFormat: "Ymd",
                minDate: "today",
                disableMobile: "true",
                locale: {
                    weekdays: {
                        shorthand: ["S", "M", "T", "W", "T", "F", "S"],
                        longhand: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday",
                        ],
                    }
                },
                onReady: (dateObj, dateStr, instance) => {
                    instance.altInput.setAttribute('aria-label', elDateToField.getAttribute("aria-label"));
                },
                onChange: function(selectedDates, dateStr, instance) {

                    fpDateFromField.set("maxDate", dateStr);

                    // Reset auto date field
                    elAutoDateField.selectedIndex = 0;

                },
            });

            elDateToField.setAttribute("readonly", false);

        }

        function init() {

            try {

                elEventsSearchForm = document.querySelector(".events-search-form");

                if (elEventsSearchForm) {

                    elAutoDateField = document.querySelector(".events-search-form__auto-date");

                    setupAutoDateField();

                    setupDatePickerFields();

                }

            } catch (error) {
                console.error(error);
            }

        }

        return {
            init: init
        };

    })();

    document.addEventListener("DOMContentLoaded", function () {
        eventsSearchForm.init();
    });

})();
